import { ErrorResponse, Uuid } from 'ValueObjects';
import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from '@tanstack/react-query';

export type UpdateProfilePictureMutationProps = {
  userId: Uuid;
  profilePictureId?: string | null;
};

export const UpdateProfilePictureMutation = async ({
  ...values
}: UpdateProfilePictureMutationProps): Promise<AxiosResponse> =>
  axios.put(`api/profile/user/${values.userId}/update-profile-picture`, {
    ...values,
  });

export const useUpdateProfilePictureMutation = (
  options: UseMutationOptions<
    AxiosResponse,
    AxiosError<ErrorResponse>,
    UpdateProfilePictureMutationProps
  > = {}
): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorResponse>,
  UpdateProfilePictureMutationProps
> =>
  useMutation<
    AxiosResponse,
    AxiosError<ErrorResponse>,
    UpdateProfilePictureMutationProps
  >(UpdateProfilePictureMutation, {
    useErrorBoundary: false,
    ...options,
  });
